import { useState, useEffect, useCallback } from 'react';
import { getTables, getGroups } from '../services/api';

export const useTables = (restaurantId) => {
  const [tables, setTables] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadTables = useCallback(async () => {
    if (!restaurantId) {
      setTables([]);
      setGroups([]);
      setLoading(false);
      return;
    }

    try {
      const [tablesRes, groupsRes] = await Promise.all([
        getTables(),
        getGroups().catch(() => ({ groups: [] }))
      ]);
      setTables(tablesRes.tables || tablesRes || []);
      setGroups(groupsRes.groups || []);
    } catch (error) {
      console.error('Error loading tables:', error);
      setTables([]);
      setGroups([]);
    } finally {
      setLoading(false);
    }
  }, [restaurantId]);

  useEffect(() => {
    loadTables();
  }, [loadTables]);

  return { tables, groups, loading, refreshTables: loadTables };
};
